export const SET_PRICES = "SET_PRICES";

export function setPrices(payload) {
  return {
    type: SET_PRICES,
    payload
  };
}
